import { z } from 'zod/v4';

import { blockSchema } from './block.schema';

export const mobileInstructionSchema = z.object({
  accountId: z.string().min(1).optional(),
  deviceId: z.string().min(1).optional(),
  partnerId: z.string().min(1).optional(),
  assetId: z.string().min(1).optional(),
  vehicleGroupIds: z.array(z.number()).optional(),
  blocks: z.array(blockSchema).optional(),
});

export type MobileInstructionGroup = z.infer<typeof mobileInstructionSchema>;
